// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"a15ec0ce","176":"522dcf45","912":"36943486"}[chunkId] + ".chunk.js";
};